<template>
  <section class="report-wrapper" id="pdf-content">
    <b-card no-body>
      <table class="w-100">
        <thead>
          <tr>
            <td>
              <div class="header-space">
                <b-card-body class="report_header pb-0">
                  <div class="company">
                    <h3 class="mb-1 text-left colorBlack">
                      {{ userData.company_name_cn }}
                    </h3>
                  </div>
                  <div class="title d-flex justify-content-between">
                    <h5 class="mb-0 colorBlack">貸款報表</h5>
                    <label>列印時間：{{ getDateTime() }}</label>
                  </div>
                  <div class="info my-50">
                    <b-row>
                      <b-col cols="10">
                        <b-row>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>供款日期：</b></b-col>
                              <b-col
                                cols="8"
                                v-if="
                                  date_range.from ||
                                  date_range.to
                                "
                              >
                                {{ date_range.from }} -
                                {{ date_range.to }}
                              </b-col>
                              <b-col cols="8" v-else> 不限 </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>團隊類別：</b></b-col>
                              <b-col
                                cols="8"
                                v-if="team_category"
                              >
                                {{ team_category }}
                              </b-col>
                              <b-col cols="8" v-else> 不限 </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>借貸類型：</b></b-col>
                              <b-col
                                cols="8"
                                v-if="loan_type"
                                >{{
                                  loan_type
                                }}</b-col
                              >
                              <b-col cols="8" v-else> 不限 </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="6">
                            <b-row>
                              <b-col cols="4"><b>支付方式：</b></b-col>
                              <b-col
                                cols="8"
                                v-if="payment_method"
                                >{{
                                  payment_method
                                }}</b-col
                              >
                              <b-col cols="8" v-else> 不限 </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <b-card-body class="py-0 report_content">
                <table class="report-table">
                  <thead>
                    <tr>
                      <th>貸款日期</th>
                      <th>合約編號</th>
                      <th>客戶類型</th>
                      <th>借款人姓名</th>
                      <th>身份證號碼</th>
                      <th>貸款金額</th>
                      <th>總期數</th>
                      <th>供款週期</th>
                      <th>年利率</th>
                      <th>支付方式</th>
                      <th>團隊類別</th>
                      <th>借貸類型</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item of reportList" :key="item.id">
                      <th>{{ item.loan_date }}</th>
                      <th>{{ item.contract_number }}</th>
                      <th>{{ item.is_new_customer ? "新客戶" : "舊客戶" }}</th>
                      <th>{{ item.name_cn }}</th>
                      <th>{{ item.id_number }}</th>
                      <th>{{ formatCurrency(item.total_amount) }}</th>
                      <th>{{ item.period }}期</th>
                      <th>{{ item.is_monthly ? "月供" : "半月供" }}</th>
                      <th>{{ item.annual_interest_rate }}</th>
                      <th>{{ item.payment_method }}</th>
                      <th>{{ item.team_category }}</th>
                      <th>{{ item.loan_type }}</th>
                    </tr>
                  </tbody>
                </table>
              </b-card-body>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div class="footer-space">&nbsp;</div>
            </td>
          </tr>
        </tfoot>
      </table>
      <b-card-body class="report_footer py-0">
        <table class="report-table">
          <tfoot>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>{{ formatCurrency(totalAmount) }}</th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </tfoot>
        </table>
        <b
          v-if="loading"
          class="d-flex justify-content-center align-items-center"
        >
          <b-spinner small class="mr-1"></b-spinner>
          載入中...
        </b>
        <b
          v-else-if="reportList.length == 0"
          class="d-flex justify-content-center"
          >沒有過濾或沒有符合條件的數據</b
        >
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardText, BSpinner } from "bootstrap-vue";

import { mapFields } from "vuex-map-fields";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  methods: {},
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BSpinner
  },
  props: {
    reportList: {
      type: Array,
      required: true,
    },
    loan_type: {
    },
    payment_method: {
    },
    team_category: {
    },
    date_range:{},
    loanTypeOptions: {
      type: Array,
      required: true,
    },
    paymentMethodOptions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  mounted() {
    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
  computed: {
    ...mapFields(["controlValue"]),
    totalAmount() {
      return this.reportList.reduce(
        (acc, item) => acc + Number(item.total_amount),
        0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
.report-table {
  font-size: 12px;
  tfoot {
    th {
      width: 40px;
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        width: 55px;
      }
      &:nth-child(6) {
        width: 100px;
      }
    }
  }
  th {
    width: 50px;
    font-size: 11px;
  }
}
</style>